import { NO_LOCATION_KEY } from './mapConstants.js';

export const checkImageExists = async (imagePath) => {
    if (!imagePath) return false;
    try {
        const response = await fetch(imagePath, { method: 'HEAD', cache: 'no-cache' });
        return response.ok;
    } catch (error) {
        return false;
    }
};
const DESIRED_MAP_ORDER = ['Cave', 'Ruins', 'Crypt', 'Inferno', 'IceCave', 'IceAbyss'];

export async function processManifest(manifestData) {
    console.log("[mapUtils.js] processManifest called with raw manifestData:", manifestData);

    if (!manifestData || typeof manifestData !== 'object' || Object.keys(manifestData).length === 0) {
        console.error("[mapUtils.js] processManifest received empty or invalid manifestData. Returning empty.");
        return { processedData: {}, firstValidMapType: null };
    }

    const processedData = manifestData;
    const mapKeys = Object.keys(processedData);
    let firstValidMapType = null;

   
    for (const desiredMap of DESIRED_MAP_ORDER) {
        if (processedData[desiredMap]) {
            firstValidMapType = desiredMap;
            break;
        }
    }

    if (!firstValidMapType && mapKeys.length > 0) {
        const sortedMapKeys = [...mapKeys].sort();
        firstValidMapType = sortedMapKeys[0];
        console.log(`[mapUtils.js] No map from DESIRED_MAP_ORDER found. Falling back to first sorted key: ${firstValidMapType}`);
    }

    if (!firstValidMapType) {
        console.warn("[mapUtils.js] Could not determine a first valid map type from the manifest.");
    }

    console.log("[mapUtils.js] processManifest returning:", { processedData, firstValidMapType });
    return { processedData, firstValidMapType };
}